<template>
  <div class="inputs-disabled-info tabs-level">
    <BbIcon size="medium" name="information" type="filled" />
    <TextBody :i18n-key="infoText" :body-type="1" />
  </div>
</template>

<script>
import TextBody from '~/components/common/TextBody.vue';

export default {
  name: 'InputDisabledBannerInfo',
  components: {
    TextBody,
  },
  props: {
    infoText: {
      type: String,
      default: 'assist.sharedConversationOnlyOwnerCanChat',
    },
  },
};
</script>

<style scoped lang="scss">
.inputs-disabled-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  display: flex;
  align-items: center;
  gap: $bb-spacing-2;
  padding: $bb-spacing-3 $bb-spacing-4;
  background: $bb-neutral-6;
  border-radius: 12px;
  margin: $bb-spacing-3 0;

  i {
    color: #fdb91a;
  }
}

.tabs-level {
  margin-top: $bb-spacing-2;
}
</style>
